


















import { Vue, Component, Prop, Ref, Emit, Inject, Watch } from 'vue-property-decorator'
import { FormDef, FieldDef } from '@/types'
import EditFormGroup from '../edit-form-group/index.vue'

@Component({
  components: { }
})
export default class EditForm extends Vue {
  @Prop({ type: Number, default: 8 }) span!: number

  @Prop({ type: Number, default: 6 }) xl!: number

  @Prop(Array) def!: FieldDef[]

  @Prop({ default: () => ({}) }) form!: Record<string | number, any>

  @Prop({ type: String, default: 'top' }) labelPosition!: 'top' | 'left' | 'right'

  @Prop() disabled!: boolean

  @Prop(String) labelWidth!: string

  @Prop({ type: Boolean, default: true }) isSubmit!: boolean

  @Emit() submit (params: Record<string | number, any>) { /* */ }

  @Prop() resetCb!: any

  @Ref() fm!: any

  @Inject({ default: () => null }) getEditFormGroup!: () => EditFormGroup

  get group (): EditFormGroup {
    return this.getEditFormGroup()
  }

  get formDef (): FormDef {
    const vm: any = this as any
    return {
      options: {
        labelPosition: this.labelPosition,
        labelWidth: this.labelWidth,
        size: 'small',
        disabled: this.group?.disabled || this.disabled
      },
      controls: [
        {
          type: 'grid',
          columns: (this.def || []).map(v => ({ ...grid(v), controls: [(v as any).def || v] })),
          options: {
            gutter: 36
          }
        }
      ]
    }

    function grid (row: any) {
      return {
        span: (row as any).span || vm.span,
        xl: (row as any).xl || (row as any).span || vm.xl,
        offset: (row as any).offset,
        push: (row as any).push,
        pull: (row as any).pull
      }
    }
  }

  forSubmit (): Promise<Record<string | number, any>> {
    return this.fm.submit()
  }

  onSubmit () {
    this.fm.submit().then((params: any) => {
      this.submit(params)
    })
  }

  onReset () {
    this.fm.reset()
    this.resetCb && this.resetCb()
  }

  @Watch('form') formChange () {
    if (this.form && this.fm) Object.assign(this.fm.form, this.form || {})
  }

  created () {
    if (this.group) this.group.forms.push(this)
  }

  mounted () {
    if (this.form) Object.assign(this.fm.form, this.form || {})
    console.log('scopedSlots', this.$scopedSlots)
  }

  beforeDestroy () {
    if (this.group) {
      const idx = this.group.forms.findIndex(v => v === this)
      if (idx >= 0) this.group.forms.splice(idx, 1)
    }
  }
}
